/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AIPlaygroundListModelsResponse {
    getFixupPrototypeFunction() { return AIPlaygroundListModelsResponse.fixupPrototype; }

    static newInstance(model: Partial<AIPlaygroundListModelsResponse>): AIPlaygroundListModelsResponse {
        let obj = Object.assign(new AIPlaygroundListModelsResponse(), model);
        AIPlaygroundListModelsResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AIPlaygroundListModelsResponse>): AIPlaygroundListModelsResponse {
        if (!model) return null;
        return AIPlaygroundListModelsResponse.newInstance(<AIPlaygroundListModelsResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AIPlaygroundListModelsResponse) {
        if (!obj) return;

        models.AIPlaygroundListModelsResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AIPlaygroundListModelsResponse): boolean {
        Object.setPrototypeOf(obj, AIPlaygroundListModelsResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.models) {
            for (let val of this.models) {
                models.AIPlaygroundModelSummary.fixupPrototype(val);
            }
        }
    }

    /**
     * Available Bedrock models and inference profiles
     */
    models: Array<models.AIPlaygroundModelSummary>;

}
